import { useHistory, Link } from "react-router-dom";
import { useRef, useState } from "react";
import style from "./style.module.scss";

function Event({ page, text, side }) {
  const history = useHistory();

  const [showMore, setShowMore] = useState(false);

  const parent = useRef();
  const content = useRef();

  console.log("TEXT", { text, page, side });

  // useEffect(() => {
  //   if (!window.scrolltasks) window.scrolltasks = [];

  //   const task = () => {
  //     if (!parent.current | !content.current) return;

  //     const level =
  //       Math.max(
  //         -parent.current.clientHeight,
  //         Math.min(
  //           Math.min(
  //             parent.current.getClientRects()[0].top,
  //             parent.current.clientHeight
  //           ),
  //           parent.current.clientHeight
  //         )
  //       ) / parent.current.clientHeight;

  //     content.current.style.marginTop = Math.floor(level * 450 - 20) + "px";
  //     content.current.style.opacity = Math.min(
  //       Math.max(0.1, 1 - Math.sign(level) * (level * level) * 3.5),
  //       1
  //     );
  //   };

  //   window.scrolltasks.push(task);
  //   task();
  // }, []);

  return (
    <div className={style.Event + " row"} ref={parent}>
      <div className={style.innerEvent}>
        <div
          className={style.leftImage}
          style={{ backgroundImage: `url("/Images/events/left1.webp")` }}
        />

        <div className={style.rightContainer}>
          <div className={style.content} ref={content}>
            <div className={style.title + " .title-font"}>
              {text[page]?.events[side]?.title}
            </div>
            {text[page]?.events[side]?.subtitle && (
              <div className={style.subTitle + " .title-font"}>
                {text[page]?.events[side]?.subtitle}
              </div>
            )}
            <div className={style.breaker}></div>
            <div>
              <div
                className={style.text}
                dangerouslySetInnerHTML={{
                  __html: text[page]?.events[side]?.text,
                }}
              ></div>
              {showMore && (
                <div
                  className={style.text}
                  dangerouslySetInnerHTML={{
                    __html: text[page]?.events[side]?.readmore,
                  }}
                ></div>
              )}
            </div>
            <div className={style.buttonsCnt}>
              <Link to="contact">
                <div className={style.button}>CONTACTEER MIJ</div>
              </Link>
              <div
                className={style.button}
                onClick={() => {
                  setShowMore(!showMore);
                }}
              >
                LEES MEER
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Event;
